export default "__VITE_ASSET__BnWzTd_8__"